// @ts-strict-ignore
import {Component, Input, OnChanges, OnInit, SimpleChanges} from "@angular/core";
import {SimUtilityExtendedService} from "@services";

@Component({
	selector: "sim-image-viewer",
	templateUrl: "./image-viewer.component.html",
	styleUrls: ["./image-viewer.component.scss"],
	standalone: false,
})
export class ImageViewerComponent implements OnInit, OnChanges {
	@Input() media: any = null;
	public imageUrl: string = null;

	constructor(private _simUtilityService: SimUtilityExtendedService) {}

	ngOnInit() {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes["media"]) {
			if (changes["media"].currentValue !== changes["media"].previousValue) {
				this.imageUrl = this._simUtilityService.getMediaPath(this.media);
			}
		}
	}
}
